import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { GoPaperLessSelectors } from '@amfam/policy/go-paperless/data-access';
import { fromRouterActions } from '@amfam/shared/utility/navigation';

import * as fromRoot from '../../core/store';

@Component({
  template: ` <router-outlet></router-outlet> `,
  standalone: false
})
export class GoPaperlessComponent implements OnInit, OnDestroy {
  // Shared subject for completing observables
  private stop$: Subject<void> = new Subject<void>();

  constructor(private store: Store<fromRoot.RootState>) {}

  ngOnInit() {
    this.store
      .select(GoPaperLessSelectors.selectIsEnrolledGoPaperless)
      .pipe(takeUntil(this.stop$))
      .subscribe(isEnrolled => {
        if (isEnrolled) {
          this.store.dispatch(
            fromRouterActions.Go({
              path: ['/policies/gopaperless/unenroll']
            })
          );
        } else {
          this.store.dispatch(
            fromRouterActions.Go({
              path: ['/policies/gopaperless/enroll']
            })
          );
        }
      });
  }

  ngOnDestroy() {
    this.stop$.next();
    this.stop$.complete();
  }
}
